module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN334_92265793.f8b3a70b.png";